import React from 'react';
import { NavigationPage } from './successlauncher-types';
import { BlogIcon, FeedbackIcon, HelpArticlesIcon, ReleaseNotesIcon, VideosIcon, SpeakToAnExpertPhoneIcon } from './Icons';
import { analyticsTrack } from '../helpers/AnalyticsUtility';

export interface ResourceCenterProps {
  selectPage: (page: NavigationPage) => void;
  onClose: VoidFunc;
}

const AnalyticsButtonClickedEventName = 'Success Launcher Button Clicked';

export default function ResourceCenter(props: ResourceCenterProps) {
  return (
    <div className="resource-center">
      {window.Intercom ? (
        <button
          className="plain-button"
          onClick={() => {
            analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Help Articles' });
            props.onClose();
            window.Intercom('showSpace', 'help');
          }}
        >
          <span className="icon-wrapper">
            <HelpArticlesIcon />
          </span>
          <span className="button-text">Help Articles</span>
        </button>
      ) : (
        <a href="https://help.goformz.com" target="helparticles" onClick={() => analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Help Articles' })}>
          <span className="icon-wrapper">
            <HelpArticlesIcon />
          </span>
          <span className="button-text">Help Articles</span>
        </a>
      )}
      <button
        className="plain-button"
        onClick={() => {
          analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Videos' });
          props.selectPage({ page: 'Videos' });
        }}
      >
        <span className="icon-wrapper">
          <VideosIcon />
        </span>
        <span className="button-text">Videos</span>
      </button>
      <a
        href="https://www.goformz.com/speak-to-a-specialist"
        target="SpeakwithanExpert"
        onClick={() => analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Speak to an Expert' })}
      >
        <span className="icon-wrapper">
          <SpeakToAnExpertPhoneIcon />
        </span>
        <span className="button-text">Speak to an Expert</span>
      </a>
      {window.Intercom ? (
        <button
          className="plain-button"
          onClick={() => {
            analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Release Notes' });
            props.onClose();
            // `showNews` isn't a type in @type/intercom-web
            window.Intercom('showNews' as ExplicitAny);
          }}
        >
          <span className="icon-wrapper">
            <ReleaseNotesIcon />
          </span>
          <span className="button-text">Release Notes</span>
        </button>
      ) : (
        <a href="https://help.goformz.com" target="releasenotes" onClick={() => analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Release Notes' })}>
          <span className="icon-wrapper">
            <ReleaseNotesIcon />
          </span>
          <span className="button-text">Release Notes</span>
        </a>
      )}
      <a href="https://blog.goformz.com" target="blog" onClick={() => analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Blog' })}>
        <span className="icon-wrapper">
          <BlogIcon />
        </span>
        <span className="button-text">Blog</span>
      </a>
      <button
        className="plain-button"
        onClick={() => {
          analyticsTrack(AnalyticsButtonClickedEventName, { button: 'Provide Feedback' });
          props.selectPage({ page: 'Provide Feedback' });
        }}
      >
        <span className="icon-wrapper">
          <FeedbackIcon />
        </span>
        <span className="button-text">Provide Feedback</span>
      </button>
    </div>
  );
}
